import { ISimpleOption } from '~/src/dash/publicaUI';

export enum EReportPeriod {
  Unknown = 0,
  LastDay,
  Last3Days,
  Last7Days,
  Last15Days,
  CurrentMonth,
  LastMonth,
  CurrentYear,
  Last31Days,
}

export const periods: Array<ISimpleOption> = [
  { key: 'period', value: String(EReportPeriod.LastDay), label: 'Last Day' },
  { key: 'period', value: String(EReportPeriod.Last3Days), label: 'Last 3 Days' },
  { key: 'period', value: String(EReportPeriod.Last7Days), label: 'Last 7 Days' },
  { key: 'period', value: String(EReportPeriod.Last15Days), label: 'Last 15 Days' },
  { key: 'period', value: String(EReportPeriod.Last31Days), label: 'Last 31 Days' },
  { key: 'period', value: String(EReportPeriod.CurrentMonth), label: 'Current Month' },
  { key: 'period', value: String(EReportPeriod.LastMonth), label: 'Last Month' },
  { key: 'period', value: String(EReportPeriod.CurrentYear), label: 'Current Year' },
];

export enum EReportFrequency {
  Unknown = 0,
  FrequencyDaily,
  FrequencyWeekly,
  FrequencyMonthly,
}

export const frequencies: Array<ISimpleOption> = [
  { key: 'frequency', value: String(EReportFrequency.FrequencyDaily), label: 'Daily' },
  { key: 'frequency', value: String(EReportFrequency.FrequencyWeekly), label: 'Weekly' },
  { key: 'frequency', value: String(EReportFrequency.FrequencyMonthly), label: 'Monthly' },
];

export enum EReportDelivery {
  Unknown = 0,
  Email,
  AWSS3,
}

export const deliveries: Array<ISimpleOption> = [
  { key: 'delivery', value: String(EReportDelivery.Email), label: 'Email' },
  { key: 'delivery', value: String(EReportDelivery.AWSS3), label: 'AWS S3' },
];
